import React from "react";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Box from "@mui/material/Box";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: theme.palette.background.default,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    textAlign: "center",
    marginTop: theme.spacing(8),
  },
  icon: {
    fontSize: 120,
    color: theme.palette.success.main,
    marginBottom: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
}));

export default function CounterPaymentSuccess() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6">Payment</Typography>
        </Toolbar>
      </AppBar>
      <Box className={classes.content}>
        <CheckCircleOutlineIcon className={classes.icon} />
        <Typography variant="h4" className={classes.title}>
          Payment Successful
        </Typography>
        <Typography variant="body1" className={classes.subtitle}>
          Your counter payment has been completed successfully.
        </Typography>
      </Box>
    </div>
  );
}
